/**
 * Normalizes string to use kebab case
 * @returns T[]
 */
export function normalizeToKebabCase(name: string) {
  return name
    .trimStart()
    .replace(/\s+/g, '-')
    .replace(/[^a-zA-Z0-9-_]/g, '-');
}
